export function getPaginationDataFromResponse(responseObject) {
  const paginationDetails = {
    totalPages: responseObject.total_pages,
    pageSize: responseObject.page_size,
    startCount: responseObject.start_count,
    endCount: responseObject.end_count,
    totalCount: responseObject.count,
    nextPageUrl: responseObject.next,
    previousPageUrl: responseObject.previous,
    currentPage: responseObject.current_page,
    nextPage: responseObject.next_page,
    previousPage: responseObject.previous_page,
    resultsExist: responseObject.results && responseObject.results.length > 0,
  }
  return paginationDetails
}

/** Pagination object that we can use to hold pagination details of a collection */
const PaginationDefaults = {
  page: 1,
  totalCount: null,
  next: null,
  previous: null,
  size: 25,
}

const Pagination = {
  create(opts = {}) {
    return Object.assign(Object.create(Pagination), PaginationDefaults, { ...opts })
  },
  calcTotalPages(pagination) {
    const { totalCount, size } = pagination
    if (!totalCount) {
      return null
    }
    return Math.ceil(totalCount / size)
  },
}

export default Pagination
